import {FirmaElectronicaModel} from "./firma-electronica.model";

export class FirmaModel{
    digital: any;
    electronica:FirmaElectronicaModel[];
}
